import {findChildByName} from "./threeUtils";
import {buildingGroup, currentDialogObject} from "../main";
import {getFloorIncludeOutside, getFloorType} from "../models/floor/floorGeneration";
import * as Globals from "../globals";
import {defaultWallElementHeight} from "../globals";
import {highlightedObject} from "./highlighting";
import {toFixedFloat} from "./utils";
import {roofGroupName} from "../constants/nameConstants";

export function reconstructUISettings(dialogId = null) {
    if (dialogId === null) {
        getFloorType();
        return;
    }

    let dialog = $('#' + dialogId);
    if (dialogId.includes("fixed")) {
        if (dialogId.includes("floor")) {
            dialog.find('#floor-type-input').val(getFloorType()).trigger('change');
        } else if (dialogId.includes("cut-out")) {
            dialog.find('#cut-out-height-input').val(Globals.defaultWallElementHeight);
        } else if (dialogId.includes("exterior-door")) {
            dialog.find('#exterior-door-height-input').val(Globals.defaultWallElementHeight);
        } else if (dialogId.includes("interior-door")) {
            dialog.find('#interior-door-height-input').val(Globals.selectedInsideDoorHeight.toString()).trigger('change');
        } else if (dialogId.includes("window")) {
            dialog.find('#window-height-range-input').attr('max', defaultWallElementHeight).trigger('change');
        }
    } else {
        let userData = highlightedObject !== null && highlightedObject !== undefined ? {...highlightedObject.userData} : null;
        if (userData === null) {
            userData = currentDialogObject.object !== null && currentDialogObject.object !== undefined ? {...currentDialogObject.object.userData} : {};
        }
        if (dialogId.includes("roof")) {
            let roofGroup = findChildByName(buildingGroup, roofGroupName);
            if (roofGroup !== null) {
                let roofData = roofGroup.userData.roof;
                dialog.find('[name="roof-type-input"][value="' + roofData.type.toString() + '"]').prop('checked', true);
                dialog.find('#roof-orientation-select').val(roofData.orientation.toString()).trigger('change');
                dialog.find('#roof-overhang-input').val(roofData.overhang.toString());
                dialog.find('#roof-overhang-range-input').val(roofData.overhang.toString());
                dialog.find('#roof-add-attika-input').prop('checked', roofData.addAttika);
                dialog.find('#roof-add-attika-height-input').val(roofData.attikaHeight.toFixed(2)).trigger('change');
            }
        } else if (dialogId.includes("window")) {
            dialog.find('#window-height-range-input').attr('max', defaultWallElementHeight.toString());
            dialog.find('#window-height-range-input').val(userData.height.toString()).trigger('input');
            dialog.find('#window-height-input').val(userData.height).trigger('keyup');
            dialog.find('#window-width-input').val(userData.width);
            dialog.find('#window-width-range-input').val(userData.width);
            // dialog.find('#window-bruestung-height-input').val(userData.bottomOffset);
        } else if (dialogId.includes("floor")) {
            dialog.find('#floor-type-input').val(getFloorType()).trigger('change');
            dialog.find('#floor-include-outside-input').prop('checked', getFloorIncludeOutside()).trigger('change');
        } else if (dialogId.includes("cut-out")) {
            dialog.find('#cut-out-height-input').val(Globals.defaultWallElementHeight);
            dialog.find('#cut-out-width-input').val(userData.width);
            dialog.find('#cut-out-width-range-input').val(userData.width);
        } else if (dialogId.includes("exterior-door")) {
            dialog.find('#exterior-door-height-input').val(Globals.defaultWallElementHeight);
            dialog.find('#exterior-door-width-input').val(userData.width);
            dialog.find('#exterior-door-width-range-input').val(userData.width);
        } else if (dialogId.includes("interior-door")) {
            dialog.find('#interior-door-height-input').val(toFixedFloat(userData.height).toString()).trigger('change');
            let width = userData.width.toFixed(2);
            dialog.find('#interior-door-width-input').val(width).trigger('change');
            //TODO: Nicht optimal ggf. anders regeln
            let value = "0";
            if (width == 0.91) {
                value = "1";
            } else if (width == 1.03) {
                value = "2";
            }
            dialog.find('#interior-door-width-range-input').val(value).trigger('change');
        } else if (dialogId.includes("pillar")) {
            dialog.find('#pillar-size-input').val(toFixedFloat(parseFloat(userData.width), 2)).trigger('change');
        } else if (dialogId.includes("beam")) {
            dialog.find('#beam-size-input').val(toFixedFloat(parseFloat(userData.thickness), 2)).trigger('change');
        }
    }
}
